export type SanitizedPathResult = { path: string; truncated: boolean } | null;

const COMMAND_PARAM_GROUP: Record<string, number> = {
  M: 2,
  m: 2,
  L: 2,
  l: 2,
  H: 1,
  h: 1,
  V: 1,
  v: 1,
  C: 6,
  c: 6,
  S: 4,
  s: 4,
  Q: 4,
  q: 4,
  T: 2,
  t: 2,
  A: 7,
  a: 7,
  Z: 0,
  z: 0,
};

const COMMAND_PATTERN = "([MmLlHhVvCcSsQqTtAaZz])";
const SPLIT_REGEX = new RegExp(
  `${COMMAND_PATTERN}|([+-]?(?:\\d*\\.\\d+|\\d+)(?:[eE][+-]?\\d+)?)`,
  "g",
);

const isCommandToken = (token: string) => /^[MmLlHhVvCcSsQqTtAaZz]$/.test(token);

export const sanitizeSegmentPath = (path: string): SanitizedPathResult => {
  if (!path || typeof path !== "string") {
    return null;
  }

  const tokens = path.match(SPLIT_REGEX);
  if (!tokens) return null;

  const safeTokens: string[] = [];
  let truncated = false;
  let index = 0;

  while (index < tokens.length) {
    const token = tokens[index];
    if (!isCommandToken(token)) {
      index += 1;
      continue;
    }

    const command = token;
    const paramGroupSize = COMMAND_PARAM_GROUP[command] ?? 0;
    index += 1;

    const numbers: string[] = [];
    while (index < tokens.length && !isCommandToken(tokens[index])) {
      numbers.push(tokens[index]);
      index += 1;
    }

    if (paramGroupSize === 0) {
      safeTokens.push(command);
      continue;
    }

    const usableNumberCount = Math.floor(numbers.length / paramGroupSize) * paramGroupSize;
    if (usableNumberCount === 0) {
      truncated = true;
      continue;
    }

    safeTokens.push(command, ...numbers.slice(0, usableNumberCount));

    if (usableNumberCount !== numbers.length) {
      truncated = true;
      break;
    }
  }

  if (safeTokens.length === 0) {
    return null;
  }

  return { path: safeTokens.join(" "), truncated };
};
